<script lang="tsx">
import {
  defineComponent,
  ref,
  type PropType, type Ref,
} from 'vue'
import useClickOutside from '../../../../composables/use-click-outside'
import NumberRange from '../../../number-range/NumberRange.vue'
import { type ComputedColumnInterface } from '../../DefaultTableInterfaces'
import { RangeNumberTableFilter } from '../../filters/Filters'
import type { RangeNumberHeaderInterface } from '../HeadersTableInterfaces'
import HeaderSort from './DefaultTableHeaderSort.vue'

export default defineComponent({
  props: {
    column: {
      type: Object as PropType<ComputedColumnInterface>,
      required: true,
    },
    /**
     * Тип числа
     *
     * Данная настройка перезаписывается значением из column.header
     */
    type: {
      type: String as PropType<'Integer'|'Float'>,
      default: 'Float',
    },
    sortField: {
      type: String,
      required: true,
    },
    enableSorting: {
      type: Boolean,
    },
    sortOrder: {
      type: Boolean as PropType<boolean>,
      default: undefined,
    },
    onSort: {
      type: Function as PropType<() => void>,
      default: undefined,
    },
  },
  setup(props) {
    const isBodyActive: Ref<boolean> = ref(false)
    const filter: RangeNumberTableFilter = props.column.filter as unknown as RangeNumberTableFilter

    const numberType = ((props.column.header as RangeNumberHeaderInterface).numberType || props.type)

    const allowNegative: boolean = (props.column.header as RangeNumberHeaderInterface).allowNegative || false

    if (numberType === 'Integer') {
      if (filter.from) filter.from = Math.round(filter.from)
      if (filter.to) filter.from = Math.round(filter.to)
    }

    const root: Ref<HTMLDivElement | null> = ref(null)

    const toggleIsBodyActive = async (val: boolean) => {
      isBodyActive.value = val
    }

    useClickOutside(root, () => toggleIsBodyActive(false))

    return () => (

      <div ref={root} class="ark-ui-table-range-number-header">
        <div class={`ark-ui-table-range-number-header-head ${isBodyActive.value ? 'active' : ''}`} onClick={() => toggleIsBodyActive(!isBodyActive.value)}>
          <div class="ark-ui-table-range-number-header-text">{ props.column.name }</div>

          <div class="ark-ui-table-range-number-header-buttons">
            <div class="ark-ui-table-range-number-header-search-box">
              <svg class="ark-ui-table-range-number-header-search" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                {/* eslint-disable-next-line max-len */}
                <path fill={`#${isBodyActive.value ? '585B69' : filter.hasValues() ? '30C1CF' : 'A3A7B9'}`} fill-rule="evenodd" clip-rule="evenodd" d="M10.8744 11.5815C9.82908 12.4664 8.47685 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7C13 8.47685 12.4664 9.82908 11.5815 10.8744L13.8536 13.1464C14.0488 13.3417 14.0488 13.6583 13.8536 13.8536C13.6583 14.0488 13.3417 14.0488 13.1464 13.8536L10.8744 11.5815ZM12 7C12 9.76142 9.76142 12 7 12C4.23858 12 2 9.76142 2 7C2 4.23858 4.23858 2 7 2C9.76142 2 12 4.23858 12 7Z" />
              </svg>
            </div>

            { props.enableSorting && props.onSort && (
              <HeaderSort column={props.column} onSort={props.onSort} sortField={props.sortField} sortOrder={props.sortOrder} />
            ) }
          </div>
        </div>

        <NumberRange
          v-show={isBodyActive.value}
          type={numberType}
          modelValue={{ from: filter.from, to: filter.to }}
          addValue={(value) => filter.addValue(value)}
          appearance='filter'
          removeValues={() => filter.removeValues()}
          allowNegative={allowNegative}
        />
      </div>

    )
  },
})
</script>

<style lang="scss" scoped>
.ark-ui-table-range-number-header {
  position: relative;

  &-head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    min-height: 24px;
    padding: 12px 16px;

    // cursor: pointer;

    &.active,
    &:hover {
      & path {
        fill: #585B69;
      }
    }
  }

  &-text {
    align-self: center;
    min-width: 40px;
    margin-right: 13px;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    color: #585B69;
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
  }

  &-buttons {
    display: flex;
    align-items: center;
    .ark-ui-table-range-number-header-search-box {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 24px;
      height: 24px;
      border-radius: 2px;
      &:hover {
        background-color: #D3D5E5;
      }
    }
  }

  &-search,
  &-reset {
    padding: 0;
    border: none;
    cursor: pointer;
    background: transparent;
  }

  // &-search {
  //   margin-right: 11px;
  // }
}
</style>
